import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoWindowMixin from './KendoWindowMixin'

export default {
    name: 'kendo-window',
    mixins: [ KendoWindowMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/index.js